import axios from 'axios'
import commonObj from '../common/common.js'

export default {
	// 获取个人信息
	getUserInfo(userId) {
		return axios({
			url: commonObj.BASEURL + '/user/get?id=' + userId,
			method: 'get',
		})
	},

	// 获取当前用户角色
	getPermsList(token) {
		return axios({
			method: 'get',
			url: commonObj.BASEURL + '/user/find/school/user/Permissions',
			headers: {
				"Authorization": token
			}
		})
	},
	// 获取当前教职工的班级列表
	getClassList(userId) {
		return axios({
			url: commonObj.BASEURL + '/user/get/manager/' + userId + '/department',
			method: 'put'
		})
	},

	// 获取材料类型  获取学校班次信息
	loadAreaTempInfo(key) {
		return axios({
			method: 'get',
			url: commonObj.BASEURL + '/config/find/' + key + '/CommonConfig',
		})
	},

	// 获取学校信息
	getSchoolMsg(schoolId) {
		return axios({
			method: 'get',
			url: commonObj.BASEURL + '/org/' + schoolId + '/info'
		})
	},

	// 上报资料上传时间
	reportUploadEvent(userId, studentUserId, fileType, imgUrl) {
		return axios({
			url: commonObj.BASEURL + '/OpLog/operateLog',
			method: 'put',
			data: {
				opType: 'uploadFileWithType',
				srcId: userId,
				srcType: fileType,
				srcVal: imgUrl,
				tarId: studentUserId
			}
		})
	},

	// 获取上报材料历史
	loadUploadEvent(params) {
		return axios({
			method: 'get',
			url: commonObj.BASEURL + '/OpLog/operateLog',
			params: params
		})
	},

	// 上传材料
	uploadFile(formData) {
		return axios.post(commonObj.BASEURL + '/article/upload/qnBucket/img', formData)
	},

	// 上传材料成功后给后端插入一条上传记录
	uploadSuccess(userId, fileType, srcValue, tarId) {
		return axios({
			url: commonObj.BASEURL + '/OpLog/operateLog',
			method: 'put',
			data: {
				opType: 'uploadFileWithType',
				srcId: userId,
				srcType: fileType,
				srcVal: srcValue,
				tarId: tarId
			}
		})
	},

	// 提交体温
	reportTemp(submitterId, userId, tempF, createTime) {
		return axios({
			url: commonObj.BASEURL + '/temp/user',
			method: 'post',
			data: {
				submitterId: submitterId,
				userId: userId,
				tempF: tempF,
				createTime: createTime
			}
		})
	},

	// findUserPage  万能接口
	findUserPage(data) {
		return axios({
			url: commonObj.BASEURL + '/user/findUserPage',
			method: 'post',
			data: data, // 这里的data是将 需要传入的参数json序列化
			headers: {
				"Content-Type": "application/json;charset=UTF-8"
			}
		})
	},



	// 根据学校ID查询当前学校的所有宿舍楼
	getSchoolDormitory(schoolId) {
		return axios({
			methods: 'get',
			url: commonObj.BASEURL + '/dormitory/get/' + schoolId + '/dormitories'
		})
	},

	// 根据宿舍楼ID查询该楼内所有宿舍列表
	getDormitorRoom(data) {
		return axios({
			method: "post",
			url: commonObj.BASEURL + '/dormitory/findAlldormRoomInfoPage',
			data: data, // 这里的data是将 需要传入的参数json序列化
			headers: {
				"Content-Type": "application/json;charset=UTF-8"
			}
		})
	},

	// 根据宿舍ID查询宿舍人员列表
	getStudentsOfDormroom(id) {
		return axios({
			methods: 'get',
			url: commonObj.BASEURL + '/dormitory/export/' + id + '/getStudentsOfDormroom',
			params: {
				retAavtar: true,
				retDept: true
			}
		})
	},

	// 查询体温上报历史记录
	getTempHistory(dataArray) {
		return axios({
			url: commonObj.BASEURL + '/temp/user/submit/page?' + encodeURI(dataArray.join('&')),
			method: 'get',
		})
	},
	// 查询体温上报历史记录2
	getTempHistory2(dataArray) {
		return axios({
			url: commonObj.BASEURL + '/temp/user/submit/page2?' + encodeURI(dataArray.join('&')),
			method: 'get',
		})
	},

	// 查询用户所对应的关联人
	getUserParents(id) {
		return axios({
			method: 'get',
			url: commonObj.BASEURL + '/dormitory/get/studentHeadTeachersAndParents?studentUserId=' + id
		})
	},

	// 查询用户关联的用户群组
	getUserGroup(gid) {
		return axios({
			url: commonObj.BASEURL + '/user/findPage/userGroup/users',
			method: 'post',
			data: {
				groupId: gid,
				pageNum: 1,
				pageSize: 1000
			}
		})
	},

	// 疫情上报  短信推送
	toTargetMessage(data) {
		console.log(data);
		return axios({
			url: commonObj.BASEURL + '/msg/send/sms/toGroup/and/stuTargetRoles',
			method: 'post',
			headers: {
				"Content-Type": "application/json;charset=UTF-8"
			},
			data: data
		})
	},

	// 查询正常体温区间
	getNormalTempArr(key) {
		return axios({
			method: 'get',
			url: commonObj.BASEURL + '/config/find/' + key + '/CommonConfig',
		})
	},

	//commitType: all, parent, school
	loadUserTempReport(userId, schoolId, scheduleList, commitType, startDate, endData) {
		let dayPeroids = []
		scheduleList.map(item => {
			dayPeroids.push('dayPeroids=2020/01/01 ' + item.startTime + ':00')
			dayPeroids.push('dayPeroids=2020/01/01 ' + item.endTime + ':00')
		})

		let dayPeroidsStr = dayPeroids.join('&')


		let params = {
			pe: endData,
			ps: startDate,
		}

		if (commitType == 'parent') {
			params['isParent'] = true
		} else if (commitType == 'school') {
			params['isParent'] = false
		}

		return axios({
			url: this.buildGetUrl('/temp/school/' + schoolId + '/user/' + userId + '/day/peroid/report', params) + '&' +
				encodeURI(dayPeroidsStr),
			method: 'get'
		})
	},

	buildGetUrl(url, data) {
		let dataArray = []
		for (let attr in data) {
			dataArray.push(`${attr}=${data[attr]}`)
		}
		return commonObj.BASEURL + url + '?' + encodeURI(dataArray.join('&'))
	},

    getUserByRfid (schoolId, code) {
        return axios({
            url: commonObj.BASEURL + '/user/get/' + schoolId + '/cardNum/' + code + '/userinfo',
            method: 'get',
        })
    }
}
